/* eslint-disable class-methods-use-this */
export default class Node {
  finalize(root, parent) {
    this.root = root;
    this.parent = parent;
  }

  toJSON() {
    return this;
  }

  toSource() {
    return '';
  }
}
